import React from "react";
import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
import { Handle, SliderRail, Track } from "../components/SliderComponents";
import { useSelector, useDispatch } from "react-redux";

const sliderStyle = {
  position: "relative",
  width: "100%",
};

export default function RatingCountFilter(props) {
  const { changeFilterAndSearch,classtype } = props;
  const loading = useSelector((state) => state.system.loading);
  const ratingcount = useSelector((state) => state.search.ratingcount);

  const [rateCount, setRateCount] = React.useState(0);

  React.useEffect(() => {
    setRateCount(ratingcount);
  }, [ratingcount]);

  const dispatch = useDispatch();

  let domain = [0, 500];
  return (
    <div className={classtype?classtype:"pricefilter"}>
      <span className="pricefilter1 filterheader">Anzahl Bewertungen</span>
      <br />
      {rateCount && rateCount * 1.0 > 0 ? (
        <span>min. {rateCount} </span>
      ) : (
        "nicht ausgewählt"
      )}
      <br />
      <br />
      <Slider
        mode={2}
        step={50}
        domain={domain}
        disabled={loading > 0}
        rootStyle={sliderStyle}
        className="slider-root"
        onChange={(val) => {
          console.log("c", val);
          if (rateCount !== ratingcount)
            changeFilterAndSearch("ratingcount", val[0]);
        }}
        onUpdate={(val) => {
          //console.log("u", val);
          //setOutboundTime(val.join("-"));
          setRateCount(val[0]);
        }}
        values={[rateCount * 1]}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>{" "}
      </Slider>
      <br />
    </div>
  );

  /*return (
    <div
      className="ratingcountfilter"
      onChange={(event) =>
        changeFilterAndSearch("ratingcount", event.target.value)
      }
    >
      <span className="ratingcountfilter1">
        Anzahl der Bewertungen
      </span>
      <br />
      <label className="ratingcountfilter2">
        <input
          className="ratingcountfilter3"
          disabled={loading > 0}
          type="radio"
          value="0"
          name="ratingcount"
          checked={ratingcount === "0"}
        />{" "}
        &nbsp;keine Auswahl
      </label>
      <br />
      <label className="ratingcountfilter4">
        <input
          className="ratingcountfilter5"
          disabled={loading > 0}
          type="radio"
          value="10"
          name="ratingcount"
          checked={ratingcount === "10"}
        />{" "}
        &nbsp;mindestens 10
      </label>
      <br />
      <label className="ratingcountfilter6">
        <input
          className="ratingcountfilter7"
          disabled={loading > 0}
          type="radio"
          value="50"
          name="ratingcount"
          checked={ratingcount === "50"}
        />{" "}
        &nbsp;mindestens 50
      </label>
      <br />
      <label className="ratingcountfilter8">
        <input
          className="ratingcountfilter9"
          disabled={loading > 0}
          type="radio"
          value="100"
          name="ratingcount"
          checked={ratingcount === "100"}
        />{" "}
        &nbsp;mindestens 100
      </label>
      <br />
      <label className="ratingcountfilter10">
        <input
          className="ratingcountfilter11"
          disabled={loading > 0}
          type="radio"
          value="200"
          name="ratingcount"
          checked={ratingcount === "200"}
        />{" "}
        &nbsp;mindestens 200
      </label>
      <br />
      <label className="ratingcountfilter12">
        <input
          className="ratingcountfilter13"
          disabled={loading > 0}
          type="radio"
          value="500"
          name="ratingcount"
          checked={ratingcount === "500"}
        />{" "}
        &nbsp;mindestens 500
      </label>
      <br />
    </div>
  );*/
}
